import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=cee29fe4&"
import script from "./ChangePassword.js?vue&type=script&lang=js&"
export * from "./ChangePassword.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports